import { BrowserRouter, Routes, Route, Navigate } from 'react-router'
import { AuthPage } from 'pages/auth'
import { LoginPage } from 'pages/auth/login'
import { DashboardPage } from 'pages/admin/dashboard'
import { AdminPage } from 'pages/admin'
import { useAuthContext } from 'context/authContext'

export const AppRouter = () => {
    const { isLoggedIn } = useAuthContext()

    return <BrowserRouter>
        <Routes>
            <Route element={isLoggedIn ? <Navigate replace to="/dashboard" /> : <AuthPage />}>
                <Route path="/login" element={<LoginPage />} />
            </Route>
            <Route element={!isLoggedIn ? <Navigate replace to="/login" /> : <AdminPage />}>
                <Route path="/dashboard" element={<DashboardPage />} />
            </Route>
            <Route
                path="*"
                element={
                    <Navigate replace to="/login" />
                }
            />
        </Routes>
    </BrowserRouter>
}